import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children"];
import React from 'react';
import SliderDot from './SliderDot';
import carouselPropTypes from '../prop-types/carouselPropTypes';

var CarouselDot = function CarouselDot(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(SliderDot, props, children);
};

CarouselDot.defaultProps = {
  dotsType: 'default'
};
export default CarouselDot;